import { inject } from '@angular/core';
import { Environment } from 'src/types/environment';
import { LoginService } from 'login';
import { ENV } from 'src/providers/environment.provider';
import { DEV_LOGIN_ROUTE_CONFIG } from '../app-routing.module';
import { UrlTree, Router } from '@angular/router';

export class AuthGuard {
    public static async canLoadApp(): Promise<UrlTree | boolean> {
        const router = inject(Router);

        const validationResult = await AuthGuard.validateUser(router);
        if (validationResult != null) { return validationResult; }

        return true;
    }

    private static async validateUser(router: Router): Promise<UrlTree | boolean | null> {
        const environment = inject<Environment>(ENV);
        const loginService: LoginService = inject(LoginService);
        if (!await loginService.getUserEmail()) {
            if (!environment.loginHost) { return router.createUrlTree([DEV_LOGIN_ROUTE_CONFIG.loginPath]); }

            location.href = `${environment.loginHost}/login?redirect=${location.href}`;
            return false;
        }

        return null;
    }
}